import React from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthContext";
import { useProfile } from "../Profile/ProfileContext";
import "../../styles/layout/subnav.css";

export default function SubnavLinks() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { isAuthed } = useAuth();
  const { profile } = useProfile();

  const LINKS = [
    { labelKey: "subnav.endingSoon", dot: true, type: "ending-soon" },
    { labelKey: "subnav.discover", type: "" },
    { labelKey: "subnav.auctions", type: "auction" },
    { labelKey: "subnav.forSale", type: "fixed" },
  ];

  const onCatalogPage = location.pathname === "/catalog";
  const currentType = onCatalogPage ? (searchParams.get("type") ?? "") : null;

  const handleClick = (type: string) => {
    navigate(type ? `/catalog?type=${type}` : "/catalog");
  };

  const hour = new Date().getHours();
  const part =
    hour < 12
      ? t("subnav.greetingMorning")
      : hour < 18
        ? t("subnav.greetingAfternoon")
        : t("subnav.greetingEvening");

  const name =
    profile?.username || profile?.displayName || t("subnav.defaultUser");

  const greeting = `${part}, ${name}`;

  return (
    <nav className="subnav-links" aria-label="Secties">
      <div className="container subnav-links__row">
        <div
          className="subnav-links__scroll"
          role="tablist"
          aria-label="Catalog filters"
        >
          <div className="subnav-links__left">
            {LINKS.map(({ labelKey, dot, type }) => {
              const isActive = currentType === type;

              return (
                <button
                  key={labelKey}
                  type="button"
                  className={`subnav-link${isActive ? " subnav-link--active" : ""}`}
                  onClick={() => handleClick(type)}
                  aria-pressed={isActive}
                >
                  {dot && <span className="subnav-dot" aria-hidden="true" />}
                  <span className="subnav-link__label">{t(labelKey)}</span>
                </button>
              );
            })}
          </div>
        </div>

        {isAuthed && <div className="subnav-greeting">{greeting}</div>}
      </div>
    </nav>
  );
}